module.exports = __webpack_public_path__ + "img/yk.a105c017.png";